import React, { Component } from 'react';
import config from 'react-global-configuration';
import RequestApi from '../Miscelania/RequestApi';

import { Link } from 'react-router-dom';
import { Tabs, Tab } from 'react-bootstrap';
import Topo from '../Layout/Topo';
import Overlay from '../Miscelania/Overlay';

// Tabs
import MattersEditTab from './Elements/MattersEditTab';
import MatterMoodleIdsTab from './Elements/MatterMoodleIdsTab';
import MatterQuestionsTab from './Elements/MatterQuestionsTab';
import TrainingMattersTab from './Elements/TrainingMattersTab';
import StaffMattersTab from './Elements/StaffMattersTab';
import MatterMaterialsTab from './Elements/MatterMaterialsTab';
import MatterAircraftModelsTab from './Elements/MatterAircraftModelsTab';
import MatterCategoriesEditTab from './Elements/MatterCategoriesEditTab';
import MatterSubjectsTab from './Elements/MatterSubjectsTab';

class MattersEdit extends Component {
  constructor(props) {
    super(props);

    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'open',        
      },
      redirect_url: false,
      loaded: 0,
      key: 1,
      matter_data: {},
      questoes: {},
      lista_questoes: {},
      treinamentos: {},
      lista_treinamentos: {},
      categorias: {},
      lista_categorias: {},
      instrutores: {},
      lista_instrutores: {},
      materiais: {},
      lista_materiais: {},
      frotas: {},
      lista_frotas: {},
      matter_moodle_ids: [],
    };
    //Handlers
    this.handleAlert = this.handleAlert.bind(this);
    this.handleLoaded = this.handleLoaded.bind(this);
    this.handleMessage = this.handleMessage.bind(this);

    this.refreshTable = this.refreshTable.bind(this);
    this.loadData = this.loadData.bind(this);
  }

  // Handlers
  handleNavTab(state, key) {
    var change = {};
    change[state] = key;
    this.setState(change);
    this.setState({overlay: {message: '', type: '', status: ''}});
  }

  handleAlert(message, type, status, mode) {
    if(mode === 'reset') {
      this.setState({overlay: {message: '', type: '', status: 'closed'}});
    } else {
      this.setState({overlay: {message: message, type: type, status: status}});
    }
  }

  handleLoaded(state) {
    if(this.state.loaded !== 2) {
      this.setState({loaded: state});      
    }
  }

  handleMessage () {
    var message = localStorage.getItem("verify_message");
    if (message !== null && typeof message !== 'undefined') {
      message = JSON.parse(message);
      var self = this;
      self.setState({overlay: {message: message.alert_message, type: message.alert_type, status: 'open'}});
      localStorage.removeItem("verify_message");
    }
  }

  //LM
  componentDidMount () {
    this.refs.request_api.header();
  }

  componentDidUpdate(prevProps, prevState) {
    if(this.state.loaded === 1 && prevState.loaded === 0) {
      this.setState({loaded: 2}, this.loadData());
    }
  }

  refreshTable (event) {
    var self = this;
    this.handleAlert('', '', 'open');
    var header = this.refs.request_api.header('application/json');
    Promise.resolve(header).then(function(value) {
      var url = config.get('api') + '/materia/buscar_questoes/'+self.props.match.params.id;
      fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'url', '/questoes');
        if (responseJson.status === 'success') {
          self.setState({questoes: responseJson.data});
        }
        self.handleAlert(event.message, event.status, 'open');
      }).then(() => {
        self.setState({overlay: {message: '', type: '', status: 'closed'}});
      }); /* Overlay */
    });
  }

  loadData () {
    var self = this;
    var header = this.refs.request_api.header('application/json');
    Promise.resolve(header).then(function(value) {
      var url = config.get('api') + '/materia/'+self.props.match.params.id;
      fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'url', '/materias');
        if (responseJson.status === 'success') {
          self.setState({matter_data: responseJson.data});
          self.setState({assuntos: responseJson.matter_subjects});
        }
      }).then(() => {
        var url = config.get('api') + '/materia/buscar_questoes/'+self.props.match.params.id;
        fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
          self.refs.request_api.validate(responseJson);
          if (responseJson.status === 'success') {
            self.setState({questoes: responseJson.data});
          }
      }).then(() => {
        var url = config.get('api') + '/materia/contar_questoes/'+self.props.match.params.id;
        fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
          self.refs.request_api.validate(responseJson);
          if (responseJson.status === 'success') {
            self.setState({qntd_questoes: responseJson.data});
          }
      }).then(() => {
        var url = config.get('api') + '/materia/categoria/contar_questoes/'+self.props.match.params.id;
        fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
          self.refs.request_api.validate(responseJson);
          if (responseJson.status === 'success') {
            self.setState({qntd_questoes_categoria: responseJson.data});
          }
      }).then(() => {
        var url = config.get('api') + '/materia/buscar_treinamentos/'+self.props.match.params.id;
        fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
          self.refs.request_api.validate(responseJson);
          if (responseJson.status === 'success') {
            self.setState({treinamentos: responseJson.data});
          }
      }).then(() => {
        var url = config.get('api') + '/materia/instrutores/'+self.props.match.params.id;
        fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
          self.refs.request_api.validate(responseJson);
          if (responseJson.status === 'success') {
            self.setState({instrutores: responseJson.data});
          }
      }).then(() => {
        var url = config.get('api') + '/materia/buscar_categorias/'+self.props.match.params.id;
        fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
          self.refs.request_api.validate(responseJson);
          if (responseJson.status === 'success') {
            self.setState({categorias: responseJson.data});
          }
      }).then(() => {
        var url = config.get('api') + '/materia/materiais/'+self.props.match.params.id;
        fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
          self.refs.request_api.validate(responseJson);
          if (responseJson.status === 'success') {
            self.setState({materiais: responseJson.data});
          }
      }).then(() => {
        var url = config.get('api') + '/materia/buscar_frotas/'+self.props.match.params.id;
        fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
          self.refs.request_api.validate(responseJson);
          if (responseJson.status === 'success') {
            self.setState({frotas: responseJson.data});
          }
      }).then(() => {
        var url = config.get('api') + '/questoes/lista';
        fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
          self.refs.request_api.validate(responseJson);
          if (responseJson.status === 'success') {
            self.setState({lista_questoes: responseJson.data});
          }
      }).then(() => {
        var url = config.get('api') + '/treinamentos/lista';
        fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
          self.refs.request_api.validate(responseJson);
          if (responseJson.status === 'success') {
            self.setState({lista_treinamentos: responseJson.data});
          }
      }).then(() => {
        var url = config.get('api') + '/categorias/lista';
        fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
          self.refs.request_api.validate(responseJson);
          if (responseJson.status === 'success') {
            self.setState({lista_categorias: responseJson.data});
          }
      }).then(() => {
        var url = config.get('api') + '/instrutores/lista';
        fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
          self.refs.request_api.validate(responseJson);
          if (responseJson.status === 'success') {
            self.setState({lista_instrutores: responseJson.data});
          }
      }).then(() => {
        var url = config.get('api') + '/materiais/lista';
        fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
          self.refs.request_api.validate(responseJson);
          if (responseJson.status === 'success') {
            self.setState({lista_materiais: responseJson.data});
          }
      }).then(() => {
        var url = config.get('api') + '/frotas/lista';
        fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
          self.refs.request_api.validate(responseJson);
          if (responseJson.status === 'success') {
            self.setState({lista_frotas: responseJson.data});
          }
      }).then(() => {
        var url = config.get('api') + '/materia/moodle_ids/'+self.props.match.params.id;
        fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
          self.refs.request_api.validate(responseJson);
          if (responseJson.status === 'success') {
            self.setState({matter_moodle_ids: responseJson.data});
          }
      }).then(() => {
        self.setState({overlay: {message: '', type: '', status: 'closed'}});
        self.handleMessage();
      }); /* Overlay */ }); /* Lista Frotas */ }); /* Lista Materiais */ }); /* Lista Instrutores */ }); /* Lista Treinamentos */ }); /* Lista Categorias */ }); /* Lista Questões */ }); /* Contagem de Questões */ });/* Contagem de Questões por categoria */ }); /* Frotas */  }); /* Materiais */ }); /* Instrutores */ }); /* Treinamentos */ }); /* Questões */ }); /* Categorias */ }); /* Moodle */
    });
  }

  render() {
    return (
<div>
  <Topo></Topo>
  <RequestApi ref={'request_api'} handleLoaded={this.handleLoaded} />
  <Overlay overlay={this.state.overlay} handleAlert={this.handleAlert} />
  <div className="container-fluid">
    <div className="conteudo">
      <h3 className="page-title pull-left">Edição de matéria - {this.state.matter_data.name}</h3>
      <Link to="/materias" className="btn btn-default pull-right"><i className="fa fa-chevron-left"></i> Voltar</Link>
      <div className="clearfix"></div>
      <hr/>
      <Tabs activeKey={this.state.key} onSelect={this.handleNavTab.bind(this, 'key')} id="controlled-tab-example">
        <Tab eventKey={1} title="Dados da matéria">
          <MattersEditTab handleAlert={this.handleAlert} matter_id={this.props.match.params.id} matter_data={this.state.matter_data} />
        </Tab>
        <Tab eventKey={2} title="Moodle">
          <MatterMoodleIdsTab handleAlert={this.handleAlert} matter_id={this.props.match.params.id} matter_moodle_ids={this.state.matter_moodle_ids} />
        </Tab>
        <Tab eventKey={3} title="Questões">
          <MatterQuestionsTab handleAlert={this.handleAlert} refreshTable={this.refreshTable} matter_id={this.props.match.params.id} questoes={this.state.questoes} lista_questoes={this.state.lista_questoes} qntd_questoes={this.state.qntd_questoes} qntd_questoes_categoria={this.state.qntd_questoes_categoria} />
        </Tab>
        <Tab eventKey={4} title="Categorias">
          <MatterCategoriesEditTab handleAlert={this.handleAlert} matter_id={this.props.match.params.id} categorias={this.state.categorias} lista_categorias={this.state.lista_categorias} />
        </Tab>
        <Tab eventKey={5} title="Treinamentos">
          <TrainingMattersTab handleAlert={this.handleAlert} matter_id={this.props.match.params.id} treinamentos={this.state.treinamentos} lista_treinamentos={this.state.lista_treinamentos} />
        </Tab>
        <Tab eventKey={6} title="Instrutores">
          <StaffMattersTab handleAlert={this.handleAlert} matter_id={this.props.match.params.id} instrutores={this.state.instrutores} lista_instrutores={this.state.lista_instrutores} />
        </Tab>
        <Tab eventKey={7} title="Materiais">
          <MatterMaterialsTab handleAlert={this.handleAlert} matter_id={this.props.match.params.id} materiais={this.state.materiais} lista_materiais={this.state.lista_materiais} />
        </Tab>
        <Tab eventKey={8} title="Frotas">
          <MatterAircraftModelsTab handleAlert={this.handleAlert} matter_id={this.props.match.params.id} frotas={this.state.frotas} lista_frotas={this.state.lista_frotas} />
        </Tab>
        <Tab eventKey={9} title="Assunto">
          <MatterSubjectsTab handleAlert={this.handleAlert} matter_id={this.props.match.params.id} assuntos={this.state.assuntos} />
        </Tab>
      </Tabs>      
    </div>
  </div>
</div>
    );
  }
}

export default MattersEdit;



// WEBPACK FOOTER //
// ./src/Components/Matters/MattersEdit.js